// Quack, this is a duck :) https://github.com/erikras/ducks-modular-redux
import { toastr } from 'react-redux-toastr';
import { handleApiError, handleError } from '../http/error';
import request from '../http/request';
import { getHeaders } from '../http/headers';

/** ************************
 * Session bundle
 ************************ */
// Actions
const TAAS_LOGIN_REQUESTED = 'Requesting TAAS login';
const TAAS_LOGIN_SUCCESS = 'TAAS login succesful';
const TAAS_LOGIN_FAILURE = 'Failed to log into TAAS';
const USER_LOGIN_REQUESTED = 'Logging in user';
const USER_LOGIN_SUCCESS = 'User logged in';
const USER_LOGIN_FAILURE = 'Failed to log in user';
const USER_LOGOUT_REQUESTED = 'Logging out user';
export const USER_LOGOUT_SUCCESS = 'User logged out';
const USER_LOGOUT_FAILURE = 'Failed to log out user';
const SESSION_EXPIRED = 'User session has expired';
const NO_ACCESS = 'User has no access';

// Reducer
const DEFAULT_STATE = {
    isTAASFetching: false,
    isFetching: false,
    user: null,
    noaccess: false,
    expired: false,
};
export default function reducer(state = DEFAULT_STATE, action) {
    switch (action.type) {
        case TAAS_LOGIN_REQUESTED:
            return Object.assign({}, state, { isTAASFetching: true });
        case TAAS_LOGIN_FAILURE:
        case TAAS_LOGIN_SUCCESS:
            return Object.assign({}, state, { isTAASFetching: false });
        case USER_LOGIN_REQUESTED:
            return Object.assign({}, state, { isFetching: true });
        case USER_LOGIN_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                expired: false,
                noaccess: false,
                user: action.user,
                redirectTo: action.redirectTo,
            });
        case USER_LOGIN_FAILURE:
            return Object.assign({}, state, { isFetching: false });
        case USER_LOGOUT_SUCCESS:
            return DEFAULT_STATE;
        case SESSION_EXPIRED:
            console.log('Session has expired');
            return Object.assign({}, DEFAULT_STATE, { expired: true });
        case NO_ACCESS:
            console.log('Access denied');
            return Object.assign({}, state, { noaccess: true });
        default:
            return state;
    }
}

// Action Creators/Thunks
export const sessionExpired = () => ({ type: SESSION_EXPIRED });
const requestTaasLogin = () => ({ type: TAAS_LOGIN_REQUESTED });
const taasLoginSuccess = token => ({ type: TAAS_LOGIN_SUCCESS });
const taasLoginFailure = error => ({ type: TAAS_LOGIN_FAILURE, error });
const requestLogin = () => ({ type: USER_LOGIN_REQUESTED });
const requestLogout = () => ({ type: USER_LOGOUT_REQUESTED });
const loginFailure = () => ({ type: USER_LOGIN_FAILURE });
const loginSuccess = user => ({ type: USER_LOGIN_SUCCESS, user });
const logoutFailure = () => ({ type: USER_LOGOUT_FAILURE });
const logoutSuccess = () => ({ type: USER_LOGOUT_SUCCESS });

export const login = (taasToken, timezoneOffset = 0) => dispatch => {
    const body = { taasToken, timezoneOffset };

    dispatch(requestLogin());

    return request
        .post('/api/jwt', body)
        .then(
            user => dispatch(loginSuccess(user)),
            error => handleApiError(error, dispatch, loginFailure())
        );
};

export const fetchUser = () => dispatch => {
    dispatch(requestLogin());

    return request
        .get('/api/jwt')
        .then(user => dispatch(loginSuccess(user)), () => dispatch(loginFailure()));
};

export const logout = () => dispatch => {
    dispatch(requestLogout());

    return request
        .del('/api/jwt')
        .then(
            () => dispatch(logoutSuccess()),
            error => handleApiError(error, dispatch, logoutFailure())
        );
};

export const authenticate = (username, password) => (dispatch, getState) => {
    dispatch(requestTaasLogin());

    const headers = new Headers(getHeaders());
    const body = JSON.stringify({ username, password });

    const appConfig = getState().config;

    if (!appConfig) {
        dispatch(taasLoginFailure());
        return;
    }

    const taasUrl = appConfig.environment.taasUrl;

    return fetch(`${taasUrl}/taas/authenticate`, {
        method: 'POST',
        headers,
        body,
    })
        .then(
            response => {
                if (response.status === 200) {
                    return response.json();
                }
                handleError("Couldn't authenticate with given username and password");
            },
            () => handleError("Couldn't authenticate with given username and password")
        )
        .then(
            ({ token }) => {
                dispatch(taasLoginSuccess());
                dispatch(login(token));
            },
            error => {
                dispatch(taasLoginFailure(error));
                toastr.error(error.message ? error.message : 'Could not authenticate via TAAS...');
            }
        );
};
